<app-header></app-header>
<h3 *ngIf="currentUser" class="usrlogged">Hola {{currentUser.firstName}}</h3>
<a *ngIf="currentUser" class="btn btn-success btn-rounded btnNext btnlogout" style="cursor:pointer" (click)="logout()">  Cerrar Sesión  </a>
<section>
    <router-outlet></router-outlet>
    <div class="container-fluid banner-city" style="background-image: url({{envtemplate.bannerbackground}});">
      
      
      <img src="{{envtemplate.banner}}" class="autos" alt="">
    </div>
</section>
<!--<app-whatsapp></app-whatsapp>-->
<app-footer></app-footer>
